export const AUTH_METHOD_HTTP_BASIC = "http_basic";
export const DETECTION_AUTO = "auto";
export const DETECTION_MANUAL = "manual";

export const DEFAULT_SOURCE_TYPE_CONFIG = {
  type: "AUTO",
  is_headless: false,
  detection: DETECTION_AUTO,
  auth: false,
  auth_method: null,
  gdrive: null,
};

const normalizeDetection = (value) => (
  value === DETECTION_MANUAL ? DETECTION_MANUAL : DETECTION_AUTO
);

const resolveOptionalBool = (value) => {
  if (value == null) {
    return null;
  }
  if (typeof value === "boolean") {
    return value;
  }
  const normalized = String(value).trim().toLowerCase();
  if (["true", "1", "yes"].includes(normalized)) {
    return true;
  }
  if (["false", "0", "no"].includes(normalized)) {
    return false;
  }
  return null;
};

const resolveAuthFields = (raw, vendor) => {
  const inferredAuth = Boolean(vendor?.feed_requires_auth);
  const legacyAuth = raw?.authenticated;
  const legacyMethod = raw?.authentication_method;
  const auth = raw?.auth != null ? Boolean(raw.auth) : (legacyAuth != null ? Boolean(legacyAuth) : inferredAuth);
  const resolvedMethod = raw?.auth_method || legacyMethod || AUTH_METHOD_HTTP_BASIC;

  return {
    auth,
    auth_method: auth ? resolvedMethod : null,
  };
};

export const parseSourceTypeConfig = (raw, vendor = null) => {
  if (!raw) {
    const authFields = resolveAuthFields({}, vendor);
    return {
      ...DEFAULT_SOURCE_TYPE_CONFIG,
      ...authFields,
    };
  }

  if (typeof raw === "object" && !Array.isArray(raw)) {
    const authFields = resolveAuthFields(raw, vendor);
    return {
      type: String(raw.type || DEFAULT_SOURCE_TYPE_CONFIG.type).toUpperCase(),
      is_headless: Boolean(raw.is_headless),
      detection: normalizeDetection(raw.detection),
      ...authFields,
      gdrive: resolveOptionalBool(raw.gdrive),
    };
  }

  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (trimmed.startsWith("{")) {
      try {
        return parseSourceTypeConfig(JSON.parse(trimmed), vendor);
      } catch {
        const authFields = resolveAuthFields({}, vendor);
        return {
          ...DEFAULT_SOURCE_TYPE_CONFIG,
          type: trimmed.toUpperCase(),
          ...authFields,
        };
      }
    }
    const authFields = resolveAuthFields({}, vendor);
    return {
      ...DEFAULT_SOURCE_TYPE_CONFIG,
      type: trimmed.toUpperCase() || DEFAULT_SOURCE_TYPE_CONFIG.type,
      ...authFields,
    };
  }

  const authFields = resolveAuthFields({}, vendor);
  return {
    ...DEFAULT_SOURCE_TYPE_CONFIG,
    ...authFields,
  };
};

export const serializeSourceTypeConfig = (config) => {
  const parsed = parseSourceTypeConfig(config);
  const payload = {
    type: parsed.type,
    is_headless: parsed.is_headless,
    detection: parsed.detection,
    auth: parsed.auth,
    auth_method: parsed.auth ? (parsed.auth_method || AUTH_METHOD_HTTP_BASIC) : null,
  };
  if (parsed.gdrive != null) {
    payload.gdrive = parsed.gdrive;
  }
  return payload;
};

export const getFormatType = (config) => parseSourceTypeConfig(config).type;

export const withManualDetection = (config, patch = {}) => serializeSourceTypeConfig({
  ...parseSourceTypeConfig(config),
  ...patch,
  detection: DETECTION_MANUAL,
});

export const updateSourceTypeConfig = (config, patch = {}) => withManualDetection(config, patch);
